import React, { useState } from 'react';
import TimeRangeSelector from './TimeRangeSelector';
import VehicleTypeSelector from './VehicleTypeSelector';
import TrafficConditionSelector from './TrafficConditionSelector';
import { FaPlus } from 'react-icons/fa';

function FilterOptions() {
    const [showTimeRange, setShowTimeRange] = useState(false);
    const [showVehicleType, setShowVehicleType] = useState(false);
    const [showTrafficCondition, setShowTrafficCondition] = useState(false);
    const [selectedTimeRange, setSelectedTimeRange] = useState(null);
    const [selectedVehicleTypes, setSelectedVehicleTypes] = useState([]);
    const [selectedTrafficConditions, setSelectedTrafficConditions] = useState(null);
  
    const handleTimeRangeApply = (timeRange) => {
      setSelectedTimeRange(timeRange);
    };
  
    const handleVehicleTypeApply = (types) => {
      setSelectedVehicleTypes(types);
    };
  
    const handleTrafficConditionApply = (conditions) => {
      setSelectedTrafficConditions(conditions);
    };
  
    const formatTimeRange = () => {
      if (!selectedTimeRange) return 'Time Range';
      const { date, time } = selectedTimeRange;
      return `${date.toLocaleDateString()} ${time}`;
    };
  
    const formatVehicleTypes = () => {
      if (selectedVehicleTypes.length === 0) return 'Vehicle Type';
      if (selectedVehicleTypes.length === 1) {
        return selectedVehicleTypes[0].charAt(0).toUpperCase() + selectedVehicleTypes[0].slice(1);
      }
      return `${selectedVehicleTypes.length} types selected`;
    };
  
    const formatTrafficConditions = () => {
      if (!selectedTrafficConditions) return 'Traffic Conditions';
      const count = selectedTrafficConditions.conditions.length;
      if (count === 0) return 'Traffic Conditions';
      if (count === 1) {
        const condition = selectedTrafficConditions.conditions[0];
        return condition.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      }
      return `${count} conditions selected`;
    };
  
    return (
      <div className="filter-options">
        <div className="section-header">
          <div className="filter-options-data-heading">Filters</div>
          <button className="add-button">
            <FaPlus size={16} color="#7CC644" />
          </button>
        </div>
        <div className="filter-options-content">
          <button 
            className={`filter-button ${selectedTimeRange ? 'active' : ''}`}
            onClick={() => setShowTimeRange(true)}
          >
            {formatTimeRange()}
          </button>
          <button 
            className={`filter-button ${selectedVehicleTypes.length > 0 ? 'active' : ''}`}
            onClick={() => setShowVehicleType(true)}
          >
            {formatVehicleTypes()}
          </button>
          <button 
            className={`filter-button ${selectedTrafficConditions?.conditions.length > 0 ? 'active' : ''}`}
            onClick={() => setShowTrafficCondition(true)}
          >
            {formatTrafficConditions()}
          </button>
        </div>
  
        <TimeRangeSelector
          isOpen={showTimeRange}
          onClose={() => setShowTimeRange(false)}
          onApply={handleTimeRangeApply}
        />
  
        <VehicleTypeSelector
          isOpen={showVehicleType}
          onClose={() => setShowVehicleType(false)}
          onApply={handleVehicleTypeApply}
        />
  
        <TrafficConditionSelector
          isOpen={showTrafficCondition}
          onClose={() => setShowTrafficCondition(false)}
          onApply={handleTrafficConditionApply}
        />
      </div>
    );
  }

export default FilterOptions; 